import { createRequestHook } from '@clover-util/use-request';
import { getTokenizationEnv } from 'util/Environment';
import { PAKMS } from 'hooks/context/cloverPaymentIframe';
import axios from 'axios';

export function useTokenizationAxiosInstance() {
  return axios.create({
    baseURL: `https://${getTokenizationEnv()}.clover.com/`,
    headers: {
      APIKEY: PAKMS
    }
  });
}

export const useTokenizationRequest = createRequestHook(useTokenizationAxiosInstance);
